import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingGandalf',
  setup(__props) {

const phrase = ref(
  "Un mago nunca llega tarde; ni pronto; llega exactamente cuando se lo propone."
);
const displayText = ref("");

const updateText = () => {
  let index = 0;
  const speed = 100; // Speed of text appearance
  const delay = 1000; // Delay before restarting (1 second)

  const interval = setInterval(() => {
    if (index < phrase.value.length) {
      displayText.value += phrase.value[index++];
    } else {
      clearInterval(interval);
      setTimeout(() => {
        displayText.value = "";
        index = 0; // Reset index to restart animation
        updateText(); // Restart text update
      }, delay);
    }
  }, speed);
};

onMounted(updateText);

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "d-flex align-center justify-center fill-height"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "text-center pa-4 card-background",
        "max-width": "90vw",
        tonal: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(displayText.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})